import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import { UploadDocumentsDropZoneItems } from 'components/application-blocks/common-blocks/UploadDocuments/UploadDocumentsDropZoneItems'
import { DocumentTypesItaly } from 'constants/values/uploadDocumentsTypes'
import './UploadDocuments.scss'
import { LifeCycleStatus } from 'constants/enums/lifeCycleStatus'

export const UploadDocumentsIt = () => {
    const { t } = useTranslation()
    const { loanApplication }: IApplicationContext = useContext(
        ApplicationDispatchContext
    )
      const isUploadStep =
        loanApplication.applicationData?.lifeCycleStatus ===
        LifeCycleStatus.DocumentsUpload
    return (
        <div className="upload-documents">
            <div className="upload-documents-with-psd2">
                <div className="upload-documents-description-top"></div>
                <div className="upload-documents-information">
                   {isUploadStep
                        ? t('UploadDocumentTextMandatory')
                        : t('UploadDocumentText')
                   }
                </div>
            </div>
            <UploadDocumentsDropZoneItems
                documentTypes={DocumentTypesItaly}
                applicationData={loanApplication}
                documentsNeedUpload={[]}
            />
        </div>
    )
}
